import React from 'react';
import { Link } from 'react-router-dom';

const ProductSidebarComponent: React.FC = () => {
  return (
    <>
      {/* Products Section */}
      <div className="mb-5 wow fadeIn" data-wow-delay="0.1s"
        style={{visibility: "visible", animationDelay: "0.1s", animationName: "fadeIn"}}>
        <div className="section-header text-start pb-4">
          <h6 className="h4 fw-bold bg-white px-2 text-uppercase mb-0">Products</h6>
        </div>
        <div className="service-list d-flex flex-column border-start border-5 border-primary">
          
          {/* Speciality Chemicals */}
          <div className="mb-3">
            <h6 className="fw-bold text-primary p-2 mb-2 bg-light">Speciality Chemicals</h6>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/products/ro-antiscalants">RO Antiscalants</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/products/boiler-water-treatment">Boiler Water Treatment</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/products/cooling-water-treatment">Cooling Water Treatment</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/products/etp-stp-chemicals">ETP/STP Chemicals</Link>
          </div>

          {/* Operation & Maintenance */}
          <div className="mb-3">
            <h6 className="fw-bold text-primary p-2 mb-2 bg-light">Operation & Maintenance</h6>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/products/municipal-wtp-stp-cetps">Municipal WTP/STP/CETPs</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/products/industrial-water-treatment-plants">Industrial Water Treatment Plants</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/products/industrial-wastewater-treatment-plants">Industrial Wastewater Treatment Plants</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/products/manpower-supply">Manpower Supply</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/products/amc-of-water-wastewater-treatment-plants">AMC of Water/Wastewater Treatment Plants</Link>
          </div>

          {/* Revamping & Modernization */}
          <div className="mb-3">
            <h6 className="fw-bold text-primary p-2 mb-2 bg-light">Revamping & Modernization</h6>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/products/water-treatment-plants-revamping">Water Treatment Plants Revamping</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/products/etp-stp-upgradation">ETP/STP Upgradation</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/products/technology-upgradation">Technology Upgradation</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/products/capacity-enhancement">Capacity Enhancement</Link>
          </div>

        </div>
      </div>
      
      {/* Download Section */}
      <div className="mb-5 wow fadeIn" data-wow-delay="0.1s"
        style={{visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp"}}>
        <div className="section-header text-start pb-4">
          <h6 className="h4 fw-bold bg-white px-2 text-uppercase mb-0">Download</h6>
        </div>
        <div className="d-flex flex-column">
          <Link className="btn btn-primary fw-semi-bold py-3 mb-3" to=""><i
            className="fa fa-download me-2"></i>Download Product Brochure (PDF)</Link>
          <Link className="btn btn-primary fw-semi-bold py-3" to=""><i
            className="fa fa-download me-2"></i>Download Technical Specs (PDF)</Link>
        </div>
      </div>
      
      {/* Contact Detail Section */}
      <div className="wow fadeIn" data-wow-delay="0.1s"
        style={{visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp"}}>
        <div className="section-header text-start pb-4">
          <h6 className="h4 fw-bold bg-white px-2 text-uppercase mb-0">Contact Detail</h6>
        </div>
        <div className="bg-dark p-4">
          <div className="d-flex align-items-center mb-4 wow fadeInUp" data-wow-delay="0.1s"
            style={{visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp"}}>
            <div className="bg-primary d-flex align-items-center justify-content-center"
              style={{width: "45px", height: "45px"}}>
              <i className="fa fa-phone-alt text-dark"></i>
            </div>
            <div className="ps-3">
              <p className="text-white mb-1">+012 345 6789</p>
              <p className="text-white mb-0">+012 345 6789</p>
            </div>
          </div>
          <div className="d-flex align-items-center mb-4 wow fadeInUp" data-wow-delay="0.1s"
            style={{visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp"}}>
            <div className="bg-primary d-flex align-items-center justify-content-center"
              style={{width: "45px", height: "45px"}}>
              <i className="fa fa-envelope text-dark"></i>
            </div>
            <div className="ps-3">
              <p className="text-white mb-1">wassertechnochem@hotmail.com</p>
              <p className="text-white mb-0">info@wassertechnochem.com</p>
            </div>
          </div>
          <div className="d-flex align-items-center wow fadeInUp" data-wow-delay="0.1s"
            style={{visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp"}}>
            <div className="bg-primary d-flex align-items-center justify-content-center"
              style={{width: "45px", height: "45px"}}>
              <i className="fa fa-map-marker-alt text-dark"></i>
            </div>
            <div className="ps-3">
              <p className="text-white mb-1">G-219, RIICO Industrial Area</p>
              <p className="text-white mb-0">Palra, Ajmer</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductSidebarComponent;
